import { GridCellProps, GridColumn } from '@progress/kendo-react-grid';
import {
  defaultGridProps,
  FilterBarFilterType,
  FilterBarMainGrid,
  FilterConfig,
  GridProvider,
  IFilterConfig,
  MainArea,
  PageCard,
  PageCardSection,
  TextIconButton,
  YesNoBooleanCell,
} from '@techsharegov/react-ui';
import { AgendaEndpoints } from 'Models/Routes';
import { Routes } from 'Navigation';
import Visibility from '@mui/icons-material/Visibility';

class CommitteeSearch {
  constructor() {
    this.isActive = true;
  }

  name?: string;
  isActive?: boolean;
  hasOpenPositions?: boolean;
}

export const Committees: React.FC = () => {
  const filters: IFilterConfig[] = [
    new FilterConfig(
      "name",
      FilterBarFilterType.SearchText,
      "Name..."
    ),
    new FilterConfig("isActive", FilterBarFilterType.YesNoBooleanRadioGroup, "Active"),
    new FilterConfig("hasOpenPositions", FilterBarFilterType.YesNoBooleanRadioGroup, "Has Open Positions"),
  ];

  return (
    <PageCard>
      <PageCardSection title="Committees">
        <MainArea>
          <GridProvider entityName="Committee">
            <FilterBarMainGrid
              filterBarProps={{
                filterConfigurations: filters,
                filterValues: new CommitteeSearch(),
              }}
              readEndpoint={AgendaEndpoints.committees.read}
              sortable={true}
              groupable={false}
              pageSize={50}
              {...defaultGridProps}
            >
              <GridColumn field="name" title="Name" />
              <GridColumn field="isActive" title="Active" cell={YesNoBooleanCell} />
              <GridColumn field="hasOpenPositions" title="Has Open Positions" cell={YesNoBooleanCell} />
              <GridColumn field="id" title=" " cell={ActionsCell} width="auto" />
            </FilterBarMainGrid>
          </GridProvider>
        </MainArea>
      </PageCardSection>
    </PageCard>
  );
};

const ActionsCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  
  const openCommittee = async () => {
    window.location.href = Routes.CommitteesView + "/" + dataItem?.id + "/Profile";
  };
  
  return (
    <td>
      <TextIconButton
        icon={Visibility}
        onClick={openCommittee}
        className="single-line-btn"
      />
    </td>
  );
};
